<template>
  <div :class="'statusLight'" :style="'background-color:'+colour+';'">
    {{label}} 
  </div>
</template>

<script>
export default {
  name: 'statusBtn',
  props: ["colour","label"],

  computed:{
    
  }
    
  
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .statusLight{
  border-radius:5px;
   font-size:inherit;
   
   padding:10px 10px;
   margin:5px;
    color:#fff;
   background-color:#ff0;
   cursor:pointer;
  }
 
</style>
